<script>
import Notification from '@/components/Notification/Notification'
import cookieManager from '@/libs/cookie-manager'

import './style.scss'

export default {
  name: 'message-bar',
  data: () => ({
    show: false,
    referrer: null,
  }),
  components: {
    Notification,
  },
  computed: {
    title() {
      const referrerMap = {
        'csdojo': 'CS Dojo subscribers',
        'stackabuse': 'Stack Abuse subscribers',
        'zhiachong': 'Zhia Chong subscribers',
        'algoexpert': 'AlgoExpert subscribers',
        'techlead': 'TechLead subscribers',
        'rachit': 'Rachit Jain subscribers',
        'joma': 'Joma Tech subscribers',
        'grind': 'Joshua Fluke subscribers',
        'forrest': 'ForrestKnight subscribers',
        'levels': 'Levels.fyi users',
      }

      const referrer = cookieManager.getRef()
      let audience = referrerMap[referrer]
      return `Welcome, ${audience}`
    },
    message() {
      return `Thanks for checking out Daily Coding Problem!`
    }
  },
  mounted() {
    const referrer = cookieManager.getRef()
    const validReferrers = ['csdojo', 'stackabuse', 'techlead', 'zhiachong', 'algoexpert', 'rachit', 'joma', 'grind', 'forrest', 'levels']
    if (validReferrers.includes(referrer)) {
      this.show = true
    }
  }
}
</script>

<template>
  <div class='message-bar'>
    <Notification
      :show="show"
      :title="title"
      :message="message"
      type="success"
    />
  </div>
</template>



// WEBPACK FOOTER //
// src/components/MessageBar/MessageBar.vue